<template>
  <div>
    <DataNavigation></DataNavigation>
    <div class="index_content">
      <Layout>
        <Sider width="208">
          <div class="right_column">
            <p class="top-tip">公告库</p>
            <div class="keyword-input">
              <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch($event)" />
            </div>
            <div class="rigit_title">
              <span>筛选</span>
              <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
                <a href="javascript:void(0)">
                  <span>{{screen_active}}</span>
                  <Icon type="md-arrow-dropup" v-if="drop_val" />
                  <Icon type="md-arrow-dropdown" v-else />
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div class="rigit_content">
              <div class="screen_ul">
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '公告类型'">
                  <div class="screen_tle" @click="screenTle.type = !screenTle.type">
                    <span>公告类型</span>
                    <Icon type="md-add" v-if="!screenTle.type" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.type">
                    <Checkbox v-model="checkAll.type" class="all_option" :disabled="checkAll.type" @on-change="handleCheckAll('type')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.type" @on-change="handleChangeOption($event, 'type')">
                      <Checkbox v-for="(item,index) in meta.notice_type" :label="item" :key="index" v-show="index < 10 || showAll">
                        <span>{{item}}</span>
                      </Checkbox>
                    </CheckboxGroup>
                    <span class="more_sel" @click="showAll = !showAll" v-show="meta.notice_type && meta.notice_type.length > 10">
                      <template v-if="!showAll">查看更多</template>
                      <template v-else>收起更多</template>
                    </span>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '公告时间'">
                  <div class="screen_tle" @click="screenTle.time = !screenTle.time">
                    <span>公告时间</span>
                    <Icon type="md-add" v-if="!screenTle.time" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.time">
                    <RadioGroup v-model="selTime" vertical @on-change="handleChangeTime($event)">
                      <Radio label=""><span>不限</span></Radio>
                      <Radio v-for="(item, index) in timeOption" :label="item" :key="index">
                        <span>{{item}}</span>
                      </Radio>
                      <Radio label="zdy"><span>自定义</span></Radio>
                    </RadioGroup>
                    <div class="zdy_time" v-if="selTime == 'zdy'">
                      <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                      <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="getEntityList" :clearable="false"></DatePicker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Sider>
        <Content>
          <div class="top-tip">全部
            <Dropdown @on-click="haddleChangeSort($event)">
              <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
            <div class="sel_tle">已选条件</div>
            <div class="sel_cnt">
              <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
                <Icon type="md-close" />
              </span>
            </div>
            <div class="sel_clear">
              <span @click="handleClearOption()"><i class="iconfont">&#xe63e;</i>清空筛选</span>
            </div>
          </div>
          <div class="list_div">
            <Table :columns="listColumns" :data="listData"></Table>
            <OrgPrompt which="gg" v-if="listData.length == 5"></OrgPrompt>
            <Spin fix v-if="listLoading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          </div>
        </Content>
      </Layout>
    </div>
  </div>
</template>

<script>
import {
  noticeList
} from '../../service'
import {
  idxOf,
  remove,
  removeArrObj
} from 'js/findIndex'
import {
  listMixins
} from 'js/listMixins'
import {
  userInfo
} from 'js/userInfo'
import Nothing from '@/components/Nothing.vue'
import DataNavigation from './components/DataNavigation.vue'
import OrgPrompt from '@/components/OrgPrompt.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    Nothing,
    DataNavigation,
    OrgPrompt
  },
  data() {
    return {
      listName: '公告库',
      listColumns: [
        {
          title: '公告名称',
          minWidth: 410,
          render: (h, params) => {
            return h('a',
              {
                on: {
                  click: () => {
                    this.goDetail(params.row.id)
                  }
                },
                class: {
                  'dec-clamp': true
                }
              }, 
              params.row.title)
          }
        },
        {
          title: '涉及公司（简称）',
          width: 200,
          render: (h, params) => {
            return h('a',
              {
                on: {
                  click: () => {
                    this.goEntityDetail(params.row.entity_uid, params.row.entity_type, { active_name: 'notice' })
                  }
                },
                class: {
                  'dec-clamp': true
                }
              },
              params.row.entity_name)
          }
        },
        {
          title: '公告类型',
          width: 200,
          render: (h, params) => {
            return h('div', filter.empty(params.row.notice_type))
          }
        },
        {
          title: '公告时间',
          width: 166,
          render: (h, params) => {
            return h('span', filter.timeTrans(params.row.pub_date))
          }
        }
      ],
      params: {
        user_key: '',
        type: [],
        year: '',
        s_time: '',
        e_time: '',
        keyword: '',
        page: 1,
        sort_type: ''
      },
      screen_dropdown: ['全部', '公告类型', '公告时间'],
      //筛选条件是否展开
      screenTle: {
        type: false,
        time: false
      },
      //不限
      checkAll: {
        type: true,
      },
      showAll: false,
      areasScope: 0,
      wholeScope: 0,
      chinaNum: 0,
      foreignNum: 0,
      yearNum: [],
      tagNum: [],
      countryNum: 0,
      availableNum: [],
      sort_id: 0,
      sort_list: [
        { id: 0, name: '公告时间倒序' },
        { id: 1, name: '公告时间正序' }
      ],
      position_id: ''
    }
  },
  computed: {
    haveOption() {
      let optionYear = [],
        optionStart = [],
        opitonEnd = [],
        optionKeyWord = [],
        optionType = []

      this.params.type.map((a) => {
        optionType.push({
          type: 'type',
          name: a,
          value: a
        })
      })

      if (this.params.year != '' && this.selTime != 'zdy') {
        optionYear = {
          type: 'year',
          name: this.params.year,
          value: this.params.year
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time
        }
      }
      if (this.params.e_time != '') {
        opitonEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time
        }
      }
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }
      return [].concat(
        optionYear,
        optionStart,
        opitonEnd,
        optionKeyWord,
        optionType
      )
    }
  },
  methods: {
    /**
     * 获取列表
     */
    async getEntityList() {
      this.params.sort_type = this.sort_id
      this.params.user_key = this.user_key
      if(this.params.s_time) {
        this.params.s_time = moment(this.params.s_time).format('YYYY-MM-DD')
      }
      if(this.params.e_time) {
        this.params.e_time = moment(this.params.e_time).format('YYYY-MM-DD')
      }
      this.listLoading = true
      let res = await noticeList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        if (this.params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption(ref) {
      this.params = {
        type: [],
        year: '',
        s_time: '',
        e_time: '',
        keyword: '',
        page: 1
      }
      this.checkAll = {
        type: true,
      }
      this.selTime = ''
      this.search_ipt = ''
      this.getEntityList()
    },
    /**
     * 前往政策详情页
     */
    goDetail(id) {
      if (this.$store.state.user_key) {
        const {
          href
        } = this.$router.resolve({
          name: "NoticeDetail",
          params: {
            id: id
          }
        })
        window.open(href, '_blank')
      } else {
        this.login()
      }
    }
  },
  created() {
    if (this.$store.state.notice_params != '') {
      this.params = { ...this.$store.state.notice_params }
      this.params.page = 1
      this.sort_id = this.params.sort_type
    }
    this.getMeta2(['notice_type'])
    this.getEntityList()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    this.$store.commit('updateNoticeParams', this.params)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
</style>
